import { type ReactNode } from 'react'

export function FooterText({ children }: { children: ReactNode }) {
  const footerTextClass =
    'not-italic font-normal text-[12px] leading-[16px] tracking-[0.04px] text-[#65636D] mt-0 mb-[64px]'

  return <div className={footerTextClass}>{children}</div>
}
